import { render } from "./CarDetails.vue?vue&type=template&id=fbd8c008"
import script from "./CarDetails.vue?vue&type=script&lang=js"
export * from "./CarDetails.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Tomer\\projects\\pmaculator-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__